const getItemsWithFakePrices = items =>
  items.map(item => ({
    ...item,
    displayPrice: Math.round(item.price * 100),
  }));

export { getItemsWithFakePrices };
